export function getStoredDoctorTheme() {
    var _a;
    if (typeof document === "undefined")
        return null;
    const cookieTheme = (_a = document.cookie.match(/theme=([^;]+)/)) === null || _a === void 0 ? void 0 : _a[1];
    if (cookieTheme === "light" || cookieTheme === "dark")
        return cookieTheme;
    try {
        const localTheme = localStorage.getItem("theme");
        if (localTheme === "light" || localTheme === "dark")
            return localTheme;
    }
    catch (_b) {
        // ignore
    }
    return null;
}
export function persistDoctorTheme(theme) {
    try {
        localStorage.setItem("theme", theme);
    }
    catch (_a) {
        // ignore
    }
    document.cookie = `theme=${theme}; Path=/; Max-Age=31536000; SameSite=Lax`;
    if (theme === "dark") {
        document.documentElement.classList.add("dark");
    }
    else {
        document.documentElement.classList.remove("dark");
    }
}
export function resolveDoctorTheme(storedTheme, backendTheme) {
    if (storedTheme)
        return storedTheme;
    if (backendTheme === "light" || backendTheme === "dark")
        return backendTheme;
    return null;
}
